/*
	s_addtocart.js
*/

$(document).ready(function(){
	  /* ADD TO CART */
    if(window.currentPageType == window.PAGE_TYPE_INSTRUMENTS) {
        $("#buy-button").click(function() {
            if(!addedToCart) {
                $.ajax({
                    type: "POST",
                    url: "/cart/add",
                    data: $(".product-variant-id").serialize(),
                    beforeSend: function() {
                        document.getElementById('buy-link').innerHTML = '...';
                    },
                    success: function(data) {
                        document.getElementById('buy-link').innerHTML = '&#x7e;'; // TILDE ~
                        cartLink = document.getElementById('menu-link-cart');
                        cartLinkMobile = document.getElementById('menu-link-cart-mob');
                        cartText = cartLink.innerHTML;
                        itemCountStr = cartText.substring(cartText.indexOf('(')+1, cartText.indexOf(')'));
                        itemCount = 1;
                        if(!isNaN(itemCountStr)) {
                            itemCount = parseInt(itemCountStr)+1;
                        }
                        cartLink.innerHTML = 'cart ('+itemCount+')';
                        cartLinkMobile.innerHTML = 'cart ('+itemCount+')';
                        document.getElementById('buy-button').classList.remove('buy-button');
                        document.getElementById('buy-button').classList.add('buy-button-added');
                        addedToCart = true;
                        window.location.href = '/cart';
                      if (typeof rdt === 'function') {
                        rdt('track', 'AddToCart');
                      }
                    },
                });
            }
        });
    }
});